import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect } from 'react';
import { logError } from 'commons/logger';
import validateFormatZipCode from 'commons/validateFormatZipCode';
import { VALIDATE_ZIP_CODE } from 'mocks/queries';
import { ZIPCODE_ERROR_MESSAGES } from 'commons/constants';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import useIsBrowser from 'hooks/useIsBrowser';
const useIsZipCodeServiceable = zip => {
  const $ = _c(21);
  const isBrowser = useIsBrowser();
  let t0;
  let trimmedZipCode;
  if ($[0] !== zip) {
    trimmedZipCode = zip?.toString()?.trim();
    t0 = !!trimmedZipCode && validateFormatZipCode(trimmedZipCode);
    $[0] = zip;
    $[1] = t0;
    $[2] = trimmedZipCode;
  } else {
    t0 = $[1];
    trimmedZipCode = $[2];
  }
  const isValidZipCodeFormat = t0;
  let t1;
  if ($[3] !== trimmedZipCode) {
    t1 = {
      zip: trimmedZipCode
    };
    $[3] = trimmedZipCode;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const t2 = !isValidZipCodeFormat || !isBrowser;
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = {
      variables: t1,
      skip: t2
    };
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const {
    data,
    error: queryError,
    loading,
    refetch: refetchQuery
  } = useSuspenseQuery(VALIDATE_ZIP_CODE, t3);
  let t4;
  if ($[8] !== refetchQuery) {
    t4 = async updatedZipCode => {
      const updatedTrimmedZipCode = updatedZipCode?.toString()?.trim();
      const updatedIsValidZipCodeFormat = !!updatedTrimmedZipCode && validateFormatZipCode(updatedTrimmedZipCode);
      if (!updatedIsValidZipCodeFormat) {
        return {
          error: ZIPCODE_ERROR_MESSAGES.ZIPCODE_IS_INVALID_FORMAT,
          isZipCodeServiceable: false
        };
      }
      const {
        data: updatedData,
        error: updatedQueryError
      } = await refetchQuery({
        zip: updatedTrimmedZipCode
      });
      if (!!updatedTrimmedZipCode && updatedQueryError) {
        logError(updatedQueryError, "Unexpected error in useIsValidZipCode");
      }
      const updatedIsZipCodeServiceable = updatedIsValidZipCodeFormat && !updatedQueryError && updatedData?.validateZipCode?.isValid;
      const updatedNonServiceableZipCodeError = updatedData?.validateZipCode?.errors?.[0]?.message;
      return {
        error: updatedQueryError ? ZIPCODE_ERROR_MESSAGES.UNEXPECTED_ERROR : undefined,
        nonServiceableZipCodeError: updatedNonServiceableZipCodeError,
        isZipCodeServiceable: updatedIsZipCodeServiceable
      };
    };
    $[8] = refetchQuery;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const refetch = t4;
  const isLoading = !data && loading;
  let t5;
  let t6;
  if ($[10] !== isLoading || $[11] !== queryError || $[12] !== trimmedZipCode) {
    t5 = () => {
      if (!!trimmedZipCode && !isLoading && queryError) {
        logError(queryError, "Unexpected error in useIsValidZipCode");
      }
    };
    t6 = [queryError, isLoading, trimmedZipCode];
    $[10] = isLoading;
    $[11] = queryError;
    $[12] = trimmedZipCode;
    $[13] = t5;
    $[14] = t6;
  } else {
    t5 = $[13];
    t6 = $[14];
  }
  useEffect(t5, t6);
  const isZipCodeServiceable = !!(isValidZipCodeFormat && !queryError && data?.validateZipCode?.isValid);
  const nonServiceableZipCodeError = data?.validateZipCode?.errors?.[0]?.message;
  const t7 = queryError ? ZIPCODE_ERROR_MESSAGES.UNEXPECTED_ERROR : undefined;
  let t8;
  if ($[15] !== isLoading || $[16] !== isZipCodeServiceable || $[17] !== nonServiceableZipCodeError || $[18] !== refetch || $[19] !== t7) {
    t8 = {
      error: t7,
      nonServiceableZipCodeError,
      isZipCodeServiceable,
      loading: isLoading,
      refetch
    };
    $[15] = isLoading;
    $[16] = isZipCodeServiceable;
    $[17] = nonServiceableZipCodeError;
    $[18] = refetch;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};
export default useIsZipCodeServiceable;